<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close :loading="loading">
			<template #default>
				<el-tabs v-model="tabname" type="card" >
					<el-tab-pane label="快捷查询" name="fastreconciliation">
						<fastreconciliation :row="row" ref="fastreconciliation" @searchdetail="searchdetail" />
					</el-tab-pane>
					<el-tab-pane label="明细" name="detail">
						<vxe-grid ref="expressreconciliationTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
					</el-tab-pane>
				</el-tabs>
				
				<edit ref="batchedit" @success="editSubmit" />
				<exporterpfile-index ref="exporterpfileIndex" @success="exporterpfileSubmit" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="success" content="保存对账结果" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import edit from './edit/index.vue'
	import exporterpfileIndex from './exporterpfile/index.vue'
	import fastreconciliation from './fastreconciliation/index.vue'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			row: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				tabname:'fastreconciliation',
				loading:false,
				list_autorender:false,
				modal_model:false,
				modal_title: '差异对账',
				modal_width:1200,
				modal_height:800,
				updatepriceBuff:true,
				selectrows:[],
				list_formConfig: [{
						field: 'status',
						title: '核对状态',
						resetValue:0,
						itemRender: {
							defaultValue:0,
							name: '$select',
							props:{
								emptyoption:false,
								selectoptions:[]
							}
						}
					},{
						field: 'expressGenerateType',
						title: '包裹类型',
						itemRender: {
							name: '$select',
							props:{
								emptyoption:false,
								selectoptions:[{
									value:0,
									label:'单包'
								},{
									value:1,
									label:'分包'
								},{
									value:2,
									label:'子母'
								}],
							}
						}
					},{
						field: 'expressCompanyID',
						title: '快递名称',
						itemRender: {
							name: '$select',
							props:{
								emptyoption:false,
								selectoptions:[]
							}
						}
					},{
						field: 'errortext',
						title: '异常',
						itemRender: {
							name: '$select',
							props:{
								emptyoption:false,
								selectoptions:[]
							}
						}
					},{
						field: 'expressNo',
						title: '快递单号',
						itemRender: {
							name: '$input',
							props:{
								islist:true,
								importsearch:false
							}
						}
					},{
						field: 'tradeCode',
						title: '订单号',
						itemRender: {
							name: '$input',
							props:{
								islist:true,
								importsearch:false
							}
						}
					},{
						field: 'isgrab',
						title: '同步',
						itemRender: {
							name: '$select',
							props:{
								emptyoption:false,
								selectoptions:[{
									value:0,
									label:'否'
								},{
									value:1,
									label:'是'
								}],
							}
						}
					}
				],
				list_footerField:[
					{field:'adjustamount',value:0,toFixed:2},
					{field:'importamount',value:0,toFixed:2},
					{field:'amountdiff',value:0,toFixed:2},
					{field:'weightdiff',value:0,toFixed:2},
					{field:'settlementamount',value:0,toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				return new Promise((reslove)=>{
					this.$api.expressreconciliation.initdetail({
						billcode:this.row.code
					}).then((param)=>{						
						//console.log(param)
						this.list_formConfig.forEach((item)=>{
							if(param[item.field]){
								item.itemRender.props.selectoptions = param[item.field]
							}
						})
						gridOptions.proxyConfig.autoLoad = false
						gridOptions.height = 650
						gridOptions.columns = [{
								type: 'checkbox',
								title: '#',
								fixed:'left',
								width:50,
							},{
								field: 'status',
								title: '核对状态',
								fixed:'left',
								width:100,
								slots:{
									default({row}){
										if(row.status == 1){
											return <span style="color:#67C23A;margin-right:10px;" >已核对</span>
										}else{
											return <span style="color:#F56C6C;margin-right:10px;" >未核对</span>										
										}
									}
								}
							},
							{
								field: 'expressGenerateType',
								title: '类型',
								width:50,
								formatter({cellValue}){
									if(cellValue == 1){
										return '分包'
									}else if(cellValue == 2){
										return '子母'
									}else{
										return '单包'
									}
									
								}
							},
							{
								field: 'packagenum',
								title: '包裹',
								width:50,
							},
							{
								field: 'sendDate',
								title: '发货时间',
								width:100,
								//fixed:'left',
								formatter({cellValue}){
									return window.systemMethods.timestampToDate(cellValue,true)
								}
							},
							{
								field: 'importbiztime',
								title: '账单时间',
								width:100,
								//fixed:'left',
								formatter({cellValue}){
									return window.systemMethods.timestampToDate(cellValue,true)
								}
							},
							
							{
								field: 'expressNo',
								title: '快递单号',
								width:100,
								//fixed:'left',
							},
							{
								field: 'tradeCode',
								title: '订单编码',
								width:100,
								//fixed:'left',
							},
							{
								field: 'expressCompanyName',
								title: '快递名称',
								width:100,
							},
							{
								field: 'tradeCode',
								title: '订单号',
								width:100,
								//fixed:'left',
							},
							{
								field: 'shopName',
								title: '店铺名称',
								width:100,
							},
							{
								field: 'warehouseName',
								title: '仓库名称',
								width:100,
							},
							{
								field: 'totalweight',
								title: 'wms重量',
								width:100,
							},
							// {
							// 	field: 'rangeweight',
							// 	title: '重量区间',
							// 	width:100,
							// },
							{
								field: 'importweight',
								title: '账单重量',
								width:100,
							},
							// {
							// 	field: 'rangeimportweight',
							// 	title: '账单重量区间',
							// 	width:100,
							// },
							// {
							// 	field: 'adjustamount',
							// 	title: '计算金额',
							// 	fixed:'right',
							// 	width:100,
							// },
							{
								field: 'importamount',
								title: '账单金额',
								//fixed:'right',
								sortable:true,
								width:100,
							},
							{
								field: 'adjustamount',
								title: '计算金额',
								//fixed:'right',
								width:100,
							},
							{
								field: 'settlementamount',
								title: '结算金额',					
								fixed:'right',
								width:100,
								sortable:true,
								editRender:{
									name:'$inputNumber',
									props:{
										precision:2,
									},
									events:{
										change:(e)=>{
											this.rowFieldChange(e)
										}
									}
								}
							},

							{
								field: 'amountdiff',
								title: '金额差异',
								fixed:'right',
								sortable:true,
								width:100,
								slots:{
									default({row}){
										if(row.amountdiff > 0){
											return <span style="color:#F56C6C">{row.amountdiff}</span>
										}else if(row.amountdiff < 0){
											return <span style="color:#67C23A">{row.amountdiff}</span>
										}else{
											return <span >{row.amountdiff}</span>
										}
									}
								}
							},
							{
								field: 'weightdiff',
								title: '重量差异',
								fixed:'right',
								sortable:true,
								width:100,
								slots:{
									default({row}){
										if(row.weightdiff > 0){
											return <span style="color:#F56C6C">{row.weightdiff}</span>
										}else if(row.weightdiff < 0){
											return <span style="color:#67C23A">{row.weightdiff}</span>
										}else{
											return <span >{row.weightdiff}</span>
										}
									}
								}
							},
							// {
							// 	field: 'weightpercent',
							// 	title: '重量波动(%)',
							// 	width:100,
							// 	sortable:true,
							// 	//fixed:'right',
							// 	slots:{
							// 		default({row}){
							// 			if(row.weightpercent > 0){
							// 				return <span style="color:#F56C6C">{row.weightpercent}</span>
							// 			}else if(row.weightpercent < 0){
							// 				return <span style="color:#67C23A">{row.weightpercent}</span>
							// 			}else{
							// 				return <span >{row.weightpercent}</span>
							// 			}
							// 		}
							// 	}
							// },
							{
								field: 'errortext',
								title: '异常',
								width:100,						
								fixed:'right',
							},
							// {
							// 	field: 'mark',
							// 	title: '备注',
							// 	width:100,						
							// 	fixed:'right',
							// 	editRender:{
							// 		name:'$input',
							// 		props:{},
							// 		events:{
							// 			blur:(e)=>{
							// 				this.rowFieldChange(e)
							// 			}
							// 		}
							// 	}
							// },
							{
								field: 'isadjust',
								title: '已同步',
								width:60,
								fixed:'right',
								slots:{
									default({row}){
										if(row.isadjust != 1){
											return <span style="color:#F56C6C">否</span>
										}else{
											return <span style="color:#67C23A">是</span>
										}
									}
								}
							},
							{
								field: 'isignore',
								title: '忽略',
								width:120,
								fixed:'right',								
								cellRender:{
									name:'$switchs',
									events:{
										change:(e)=>{
											this.ignoreChange(e)
										}
									},
									props:{}
								},
								editRender:{
									name:'$switchs',
									events:{
										change:(e)=>{
											this.ignoreChange(e)
										}
									},
									props:{
										activeValue:1,
										inactiveValue:0
									}
								},
							}
						]
						gridOptions.toolbarConfig.buttons = [
						{
							name: '导出',
							status: 'success',
							code: 'export'
						},
						{
							name: '批量修改',
							status: 'danger',
							code: 'batchedit'
						},
						{
							name: '工具',
							status: '',
							dropdowns: [{
								name:'重新同步',
								code:'regrab'
							}]
						},
						// {
						// 	name: '导出对账模板',
						// 	status: 'primary',
						// 	code: 'exporterpfile'
						// },
						// {
						// 	name: '重置结算金额',
						// 	status: '',
						// 	code: 'resetsettlementamount'
						// },
						// {
						// 	name: '重新同步',
						// 	status: '',
						// 	code: 'regrab'
						// },
						// {
						// 	name: '自动核对',
						// 	status: 'warning',
						// 	code: 'autocheck'
						// },
						]
						gridOptions.scrollY = {
							enabled:true,
							gt:20
						}
						gridOptions.pagerConfig = {
							enabled: true,
							autoHidden: false,
							border: true,
							size: 'mini',
							perfect: false,
							currentPage: 1,
							pageSize: 1000,
							pageSizes: [1000,2000,10000],
						}
						gridOptions.formConfig.span = 6
						
						reslove()
					})
				})
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.expressreconciliation.getdetail({
						...page,
						...updateForm,
						...{billcode:this.row.code},
						...other
					}).then((res)=>{
						this.list_footerField = [
							{field:'adjustamount',value:res.adjustamountsum,toFixed:2},
							{field:'importamount',value:res.importamountsum,toFixed:2},
							{field:'amountdiff',value:res.amountdiffsum,toFixed:2},
							{field:'weightdiff',value:res.weightdiffsum,toFixed:2},
							{field:'settlementamount',value:res.settlementamountsum,toFixed:2}
						]
						resolve(res)
					})
				})
			},
			exporterpfileSubmit(e){
				this.loading = true
				this.$api.expressreconciliation.download({
					billcode:this.row.code,
					isignore:e.isignore,
					status:e.status
				}).then((blob) => {
					this.loading = false
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.style.display = 'none';
					a.href = url;
					a.download = window.systemMethods.timestampToDate(this.row.billtime,'month') +'_'+ this.row.name + '对账单.xlsx';
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
				},()=>{
					this.loading = false
				})
			},
			exporterpfile(){
				this.$refs.exporterpfileIndex.modal_show()
			},
			rowFieldChange(e){
				if(this.updatepriceBuff){
					this.loading = true
					this.updatepriceBuff = false
					this.updateprice(e.row.expressNo,{
						billcode:this.row.code,
						mark:e.row.mark,
						settlementamount:e.row.settlementamount,
					}).then(()=>{
						this.loading = false
						this.$message.success('操作成功')
						let amountdiff = e.row.importamount - e.row.settlementamount
						e.row.amountdiff = amountdiff.toFixed(2)
						this.updatepriceBuff = true
					},()=>{
						this.updatepriceBuff = true
						this.loading = false
					})
				}
				//console.log(e)
			},
			updateprice(expressNo,param){
				return new Promise((reslove,reject)=>{
					this.$api.expressreconciliation.updateprice({
						...{expressNo:expressNo},
						...param
					}).then(()=>{
						reslove()
					},()=>{
						reject()
					})
				})
			},
			ignoreChange(e){
				this.updateprice(e.row.expressNo,{
					isignore:e.row.isignore?1:0
				})
				//console.log(e.row.ignore)
			},
			batchedit(){
				let data = this.$refs.expressreconciliationTable.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.selectrows = data
				this.$refs.batchedit.modal_show()
				
			},
			resetsettlementamount(){
				let data = this.$refs.expressreconciliationTable.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let expressNo = data.map((item)=>{
					return item.expressNo
				})
				this.loading = true
				this.$api.expressreconciliation.resetsettlementamount({
					expressNo:expressNo.join(',')
				}).then(()=>{		
					this.$refs.expressreconciliationTable.commitProxy('query')
					this.loading = false
				},()=>{
					this.loading = false
				})
				
			},
			regrab(){
				let data = this.$refs.expressreconciliationTable.getCheckboxRecords()
				if(!data.length){			
					//this.$message.error('未选择数据')
					this.$confirm('未选择数据，是否重新同步所有数据?').then(()=>{
						this.loading = true
						this.$api.expressreconciliation.regrab({
							billcode:this.row.code
						}).then(()=>{		
							this.$refs.expressreconciliationTable.commitProxy('query')
							this.loading = false
						},()=>{
							this.loading = false
						})
					})
					return
				}
				let expressNo = data.map((item)=>{
					return item.expressNo
				})
				this.loading = true
				this.$api.expressreconciliation.regrab({
					expressNo:expressNo.join(','),
					billcode:this.row.code
				}).then(()=>{		
					this.$message.success('已提交同步任务')
					this.$refs.expressreconciliationTable.commitProxy('query',{isgrab:0})
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			editSubmit(e){
				let expressNo = this.selectrows.map((item)=>{
					return item.expressNo
				})
				e.billcode = this.row.code
				this.loading = true
				this.updateprice(expressNo.join(','),{...e,billcode:this.row.code}).then(()=>{
					this.loading = false
					this.$refs.expressreconciliationTable.commitProxy('query')
				},()=>{
					this.loading = false
				})
			},
			autocheck(){
				this.$confirm('是否确认自动核对?').then(()=>{
					this.loading = true
					this.$api.expressreconciliation.autocheck({
						billcode:this.row.code
					}).then(()=>{		
						this.$refs.expressreconciliationTable.commitProxy('query')
						this.loading = false
					},()=>{
						this.loading = false
					})
				})
			},
			searchdetail(e){
				this.$refs.expressreconciliationTable.commitProxy('query',{expressNo:e.expressNo})
				this.tabname = 'detail'
			},
			submit() {
				this.loading = true
				this.$api.expressreconciliation.savebill({
					billcode:this.row.code
				}).then(()=>{
					this.loading = false
					this.$emit('submit')
					this.modal_cancel()
				},()=>{
					this.loading = false
				})
			},
			reset() {
				
				//this.init()
			},
			modal_onhide(){
				this.tabname = 'fastreconciliation'
			},
			modal_cancel() {
				this.modal_model = false
				
			},
		},
		components: {
			edit,
			exporterpfileIndex,
			fastreconciliation
		}
	}
</script>